import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonDialoguesService } from './common-dialogues.service';
import { ConfirmationDialogue } from './confirmation-dialogue/confirmation-dialogue.component';
import { FormlyDialogueController } from './formly-dialogue/formly-dialogue.component';
import { FormlyView } from './formly-view.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        LoadingIndicatorModule,
        ModalModule.forChild(),
        FormlyModule,
        FormlyBootstrapModule,
        SharedUiModule,
        AnalyticsModule,
        EnhancedHelpModule
    ],
    providers: [CommonDialoguesService],
    bootstrap: [],
    declarations: [ConfirmationDialogue, FormlyDialogueController, FormlyView],
    exports: [ConfirmationDialogue, FormlyDialogueController]
})
export class CommonDialoguesModule {}
